import * as React from 'react';
import { GlobalizationContext } from '../globalization/GlobalizationContext';
/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to an [IntlService]({% slug api_intl_intlservice %}).
 */
export var useInternationalization = function () {
  return React.useContext(GlobalizationContext).intl;
};